export default {
  // ========== Matrix1View - Títulos y textos ==========
  progressionOf: 'Progresión de',
  by: 'por',
  of: 'de',
  viewOf: 'Vista de',
  without: 'sin',
  noDataFor: 'No hay',
  associatedToThisProfile: 'asociadas a este perfil',
  draft: 'Redactar',
  doesNotHaveAny: 'No cuenta con ningún',
  created: 'creado',
  noData: 'No hay',

  // ========== Tooltips y mensajes específicos ==========
  competencesWithoutCyclesInfo: 'Estas {competences} son irregulares en el {egressProfile}, puede cambiarles el {cycle} o eliminarlas; para que no afecten a la configuración de la {matrix}.',
  competenceBelongsToSuperiorLevel: 'La {competence} pertenece a un {cognitiveLevel} superior al que se encuentra en el siguiente {cycle}.',
  multipleSelectionTooltip: 'Para utilizar la selección múltiple, mantenga presionada la tecla Ctrl y a continuación, seleccione los elementos que desee agregar.',

  // ========== Confirmaciones ==========
  deleteCompetenceAssociationConfirm: '¿Está seguro de que desea eliminar la asociación de esta instancia de "{competence} en el {egressProfile}"?',
  deleteActionIrreversible: '¡Esta acción no se podrá revertir!',
  dragToReorder: 'Arrastre para reordenar',
}
